module.exports = __webpack_public_path__ + "img/979af00.svg";